const styles = () => ({
    card: {
        height: '100%',
        fontSize: '1rem',
    },
    internalContainer: {
        minHeight: '740px',
    },
    messageHolder: {
        position: 'relative',
        height: '320px',
    },
    status: {
        fontWeight: 400,
        verticalAlign: 'middle',
        margin: '0 30px 0 0',
        fontSize: '.9rem',
        display: 'inline-block',
    },
    code: {
        fontSize: '12px',
    },
    title: {},
    date: {
        fontWeight: 100,
        fontSize: '12px',
    },
    btnAction: {},
    centerProgress: {
        textAlign: 'center',
        margin: '30px 0 10px',
    },
});

export default styles;
